<template>
    <section class="next-sticky-cont">
        <button class="btn btn-l btn-primary next-btn" @click="nextBtnClicked">{{buttonText}}</button>
        <ul class="creation-progress-dots">
            <li>
                <input type="radio" name="creation-progress" id="creationStep1" value="1"  v-model="currentStepDot" disabled>
                <label for="creationStep1"></label>
            </li>
            <li>
                <input type="radio" name="creation-progress" id="creationStep2"  value="2" v-model="currentStepDot" disabled>
                <label for="creationStep2"></label>
            </li>
            <li>
                <input type="radio" name="creation-progress" id="creationStep3"  value="3" v-model="currentStepDot" disabled>
                <label for="creationStep3"></label>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    name: "createGifStickyBar",
    props: {
        step: Number,
    },
    data() {
        return {
            buttonText: "Next",
            currentStepDot: this.step,
        }
    },
    watch: {
        step: function(val) {
            this.currentStepDot = val;
            if (val ==2) {
                this.buttonText = "Create Quiz";
            }
            if (val==1) {
                this.buttonText = "Next";
            }
        },
    },
    methods: {
        nextBtnClicked() {
            this.$emit('nextBtnClicked');
        },
    }
}

</script>

<style>

</style>